import { render, staticRenderFns } from "./GangBuilding.vue?vue&type=template&id=206d08b8&scoped=true&"
import script from "./GangBuilding.vue?vue&type=script&lang=js&"
export * from "./GangBuilding.vue?vue&type=script&lang=js&"
import style0 from "./GangBuilding.vue?vue&type=style&index=0&id=206d08b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d08b8",
  null
  
)

export default component.exports